export default "__VITE_ASSET__CsN$$xeF__"